export const environment = {
  production: false,
  name: 'staging',
  target: 'hosting',
  offline: false,
  emulators: {
    auth: false,
    firestore: false,
    storage: false,
    functions: false,
  },
  repairMode: true,
  firebase: {
    apiKey: 'AIzaSyCh8SNbH4fvvQf7J3ntG2tZzhc2Mzsr5n8',
    authDomain: 'staging-damotech-platform.firebaseapp.com',
    databaseURL: 'https://staging-damotech-platform.firebaseio.com',
    projectId: 'staging-damotech-platform',
    storageBucket: 'staging-damotech-platform.appspot.com',
    messagingSenderId: '1055918849476',
    appId: '1:1055918849476:web:83f0a27692a54656',
    measurementId: 'G-9NW8M8WDH2',
  },
  appConfig: {
    domain: '.2totems.com',
    faqUrlEn: 'https://www.damotech.com/en/knowledge/logging-in',
    faqUrlFr: 'https://www.damotech.com/fr/knowledge/ouvrir-une-session',
    helpDeskUrl: 'https://www.damotech.com/knowledge/kb-tickets/new',
    websiteUrl: 'https://www.damotech.com',
    fns: 'https://staging-damotech-platform.firebaseapp.com/api',
    signupUrl: {
      en: 'https://www.damotech.com/software/watch-the-demo-video-lp',
      fr: 'https://www.damotech.com/fr/reserver-une-demo-de-la-plateforme-lp',
    },
    ngFnsOrigin: 'https://staging-damotech-platform.firebaseapp.com',
    production: {
      bucket: {
        drawings: 'staging-damotech-platform.appspot.com',
      },
      mesUrl: '',
      mesHealthCheckUrl: '',
      pubSubPrefix: 'staging-',
    },
    watson: {
      bucket: {
        drawings: 'staging-damotech-platform.appspot.com',
        import: 'staging-damotech-platform.appspot.com',
        importWork: 'staging-imports-work',
      },
      layoutDebugInfos: false,
      maxDownloadChunkSize: 10,
      maxSyncingWarehouses: 5,
      minSyncingDelay: 3600,
      maxSyncEventReplay: 500,
      pubsub: {
        import: 'staging-imports',
      },
      useWebworkers: false,
      downloadPicturesOnSync: false,
      // SC-9665: historical warehouse state snapshots. Online-only; off in production.
      warehouseStateSnapshots: true,
      sectionLayoutMode: true,
    },
    storage: {
      enabled: true,
      bucket: 'staging-damotech-platform.appspot.com',
    },
    upload: {
      maxFileSize: 2048 * 1024 * 1024,
    },
    router: {
      history: 100,
    },
    heartbeatUrl: 'https://firebasestorage.googleapis.com/v0/b/prod-tokyo-concept-157620/o/public%2Fhealthcheck.txt',
    hubspotPortalId: '44306683',
  },
  home: 'https://platform-staging.2totems.com',
  recaptcha: {
    siteKey: '6Ld5_SYjAAAAANtRu9VU-oSYEpkEESFHfIu4Xlmm',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
